import React from "react";
import "./Inspiration.css";

const Inspiration = ({ question, handleSend, allSilosExpiredOrMissing }) => {
  return (
    <div
      className={`inspiration${allSilosExpiredOrMissing ? " disabled" : ""}`}
      onClick={() => {
        if (!allSilosExpiredOrMissing) handleSend();
      }}
    >
      <p>{question}</p>
    </div>
  );
};

export default Inspiration;
